const COLORS = {
    primary: '#494DCD',
    secondary: '#FF927B;',
    white: '#ffffff',
    black: '#231F20',
    grey: '#c2c2c2',
    red: '#ff0000',
    darkBlue: '#00008b',
    redBgColor: '#FF8B8B',
    greenBgColor: '#CDFDCB',
    redTextColor: '#ff0000',
    greenTextColor: '#0ea600',
    ligthGreen: '#D5FAE9',
    darkGreen: '#418079',
    yellowIconBg: '#EDB618',
    yellow: '#EDB618',
    ligthGrey: '#E4E4E4',
    greyPassiveMenu: '#757575',
    greyText: '#757575',
    lowerRed: '#A81B05',
    lastColor: '#42A5F5',
    avgColor: '#9f9f9f',
    biggestColor: '#1F7F1C',
    colorSat: '#cc2936',
    colorAl: '#27b376',
    colorTut: '#264b96',
    colorKararsiz: '#777B7E',
    spinner: '#2fbc99',

}

export default COLORS;